import { MantineColorsTuple } from "@mantine/core";
// Primary colors
export const primary: MantineColorsTuple = [
  "#F9FAFF", // ✅ Added (extra light shade)
  "#F4F7FF",
  "#EAF0FE",
  "#AAC2FB",
  "#6A95F9",
  "#2A67F6",
  "#2458D1",
  "#1D48AC",
  "#173987",
  "#112962",
  "#E6F5FF",
  "#4F5565", // alert title color (oklch(0.373 0.034 259.733) converted to hex)
] as const;

// Expanded/highlight background
export const expandedBg = "#DCEAFD";

// Gray colors
export const gray: MantineColorsTuple = [
  "#FAFAFA", // ✅ Added (extra light gray)
  "#E5E5E5",
  "#F2F2F2",
  "#E5E5E5",
  "#BFBFBF",
  "#999999",
  "#737373",
  "#4C4C4C",
  "#262626",
  "#000000",
  "#0D0D0D", // ✅ Added (almost black)
] as const;

// Success colors
export const success: MantineColorsTuple = [
  "#F0FFF5", // ✅ Added (very light green tint)
  "#E6FFF0", // ✅ Added (light green tint)
  "#CCFFDD", // ✅ Added (soft green)
  "#FFFFFFE5",
  "#28C76F",
  "#1E9553",
  "#157A42", // ✅ Added
  "#0C5F31", // ✅ Added
  "#034520", // ✅ Added
  "#002A10", // ✅ Added (very dark green)
] as const;

// Danger colors
export const danger: MantineColorsTuple = [
  "#FFF5F5", // ✅ Added
  "#FFE5E5", // ✅ Added
  "#FFCCCC", // ✅ Added
  "#FFFFFFF2",
  "#EA5455",
  "#B03F40",
  "#902F30", // ✅ Added
  "#701F20", // ✅ Added
  "#500F10", // ✅ Added
  "#300000", // ✅ Added
] as const;

// Warning colors
export const warning: MantineColorsTuple = [
  "#FFF9F4", // ✅ Added
  "#FFF0CC", // ✅ Added
  "#FFE582", // ✅ Added
  "#FFFFFFF2",
  "#FA8C22",
  "#BF7732",
  "#996123", // ✅ Added
  "#734B14", // ✅ Added
  "#4D3505", // ✅ Added
  "#332200", // ✅ Added
] as const;

export const statusColors = {
  Pending: warning[4],
  Completed: success[6],
  "In-Progress": warning[4],
  Open: primary[5],
  "Unable to Determine": success[6],
  NA: primary[5],
  Other: success[6],
  "Query Disagreed": success[6],
  "Query Agreed": success[6],
  completed: success[6],
};

// Info colors
export const info: MantineColorsTuple = [
  "#F5F3FD", // ✅ Added
  "#EFEAFA", // ✅ Added
  "#E9E0F8", // ✅ Added
  "#F9F5FD",
  "#8E35DD",
  "#391558",
  "#2E1047", // ✅ Added
  "#230C37", // ✅ Added
  "#180826", // ✅ Added
  "#0D0416", // ✅ Added
] as const;
